import { render, staticRenderFns } from "./TopfeaturedProperty.vue?vue&type=template&id=2ad6f92e&"
import script from "./TopfeaturedProperty.vue?vue&type=script&lang=js&"
export * from "./TopfeaturedProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports